import FormulaInterface from "./FormulaInterface.ts";
import FormulaServiceInterface from "./FormulaServiceInterface.ts";
import FormulaNotFoundError from "./exception/FormulaNotFoundError.ts";

export default class FormulaService implements FormulaServiceInterface {
    formulas: Array<FormulaInterface>;

    constructor() {
        this.formulas = [];
    }

    /**
     * @param formula
     */
    add(formula) {
        this.formulas.push(formula);

        return this;
    }

    /**
     * @param index
     */
    get(index: number): FormulaInterface {
        let formula = this.formulas[index];

        if (undefined === formula) {
            throw new FormulaNotFoundError(index);
        }

        return formula;
    }

    getAll(): Array<FormulaInterface> {
        return this.formulas
    }

    getByName(name: string): FormulaInterface {
        return this.formulas.find(formula => formula.getName() === name);
    }

}





// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/FormulaService.ts